import moment from "moment";
import { IntlShape } from "react-intl";


export const ranges = (intl: IntlShape) => {
  const today = intl.formatMessage({id:"GENERIC.CALENDAR.RANGE_TODAY"})
  const yesterday = intl.formatMessage({id:"GENERIC.CALENDAR.RANGE_YESTERDAY"})
  const last7days = intl.formatMessage({id:"GENERIC.CALENDAR.RANGE_LAST_7_DAYS"})
  const last30days = intl.formatMessage({id:"GENERIC.CALENDAR.RANGE_LAST_30_DAYS"})
  const thisMonth = intl.formatMessage({id:"GENERIC.CALENDAR.RANGE_THIS_MONTH"})
  const lastMonth = intl.formatMessage({id:"GENERIC.CALENDAR.RANGE_LAST_MONTH"})
  const data: any = {}
  data[today] = [moment(), moment()];
  data[yesterday] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
  data[last7days] = [moment().subtract(6, 'days'), moment()];
  data[last30days] = [moment().subtract(29, 'days'), moment()];
  data[thisMonth] = [moment().startOf('month'), moment().endOf('month')];
  data[lastMonth] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
  return data


  
}
export const locale = (intl: IntlShape) => {

  return {
    format: intl.formatMessage({id: "GENERIC.CALENDAR.FORMAT"}),
    separator: " - ",
    applyLabel: intl.formatMessage({id: "GENERIC.OK"}),
    cancelLabel: intl.formatMessage({id: "GENERIC.CANCEL"}),
    fromLabel: intl.formatMessage({id: "GENERIC.CALENDAR.FROM"}),
    toLabel: intl.formatMessage({id: "GENERIC.CALENDAR.TO"}),
    customRangeLabel: intl.formatMessage({id: "GENERIC.CALENDAR.RANGE_CUSTOM"}),
    weekLabel: intl.formatMessage({id: "GENERIC.CALENDAR.W"}),
    daysOfWeek: [
      intl.formatMessage({id: "GENERIC.CALENDAR.WEEKDAY_SU"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.WEEKDAY_MO"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.WEEKDAY_TU"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.WEEKDAY_WE"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.WEEKDAY_TH"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.WEEKDAY_FR"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.WEEKDAY_SA"})

    ],
    monthNames: [
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_JANUARY"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_FEBRUARY"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_MARCH"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_APRIL"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_MAY"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_JUNE"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_JULY"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_AUGUST"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_SEPTEMBER"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_OCTOBER"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_NOVEMBER"}),
      intl.formatMessage({id: "GENERIC.CALENDAR.MONTH_DECEMBER"})

    ],
    firstDay: 1
  };
}

